import { FormControl, FormLabel, TextField } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

export const AppLayout = React.memo(styled.div`
  height: 100vh;

  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto 1fr;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-template-columns: 1fr;
  }
`);

export const StyledFormLabel = styled(FormLabel)`
  text-align: center;
  font-style: normal;
  font-weight: normal;
  size: 20px;
  line-height: 24px;
  margin-bottom: 1.6rem;
`;
export const StyledFormControl = styled(FormControl)`
  > div {
    margin-top: 1.7rem;
  }

  > div:nth-child(2) {
    margin-top: 0;
  }
`;
export const StyledTextField = styled(TextField)`
  .MuiFormLabel-root:not(.Mui-focused, .MuiFormLabel-filled) {
    transform: translate(14px, 15px) scale(1);
  }

  .MuiFormLabel-root.Mui-focused,
  .MuiFormLabel-root.MuiFormLabel-filled {
    text-transform: uppercase;
  }

  .MuiFormLabel-root.Mui-focused + div,
  .MuiFormLabel-root.MuiFormLabel-filled + div {
    legend {
      text-transform: uppercase;
    }
  }

  .MuiFormHelperText-root {
    text-transform: uppercase;
  }

  .MuiInputBase-root {
    max-height: 2.75rem;
  }
`;
export const InputIcon = styled.span<{ $icon: string }>`
  line-height: normal;

  ::before {
    font-family: Erply-Icons, serif;
    content: '${({ $icon }) => $icon}';
    font-size: 1.7rem;
    color: ${({ theme: { shade } }) => shade['500']};
  }
`;
export const AbsoluteCenter = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  display: flex;
  justify-content: center;
  align-items: center;
`;
